if (!customElements.get('why-shop-section')) {
    customElements.define('why-shop-section', class WhyShopSection extends HTMLElement {
        constructor() {
            super();
            this.items = this.querySelectorAll('.why-shop-item');
            this.time = 4000; // 切换间隔时间
            this.currentIndex = 0; // 当前激活项的索引
            this.interval = null; // 存储定时器
            this.hasStarted = false; // 防止重复启动
        }

        connectedCallback() {
            this.observer = new IntersectionObserver((entries) => {
                entries.forEach(entry => {
                    if (entry.isIntersecting && !this.hasStarted) {
                        this.startRotation();
                        this.hasStarted = true;
                    }
                });
            }, {
                threshold: 0.1 // 当10%的元素进入视口时触发
            });

            this.observer.observe(this);
        }

        // 开始轮播
        startRotation() {
            if (this.items.length === 0) return;

            // 立即激活第一个项目
            this.activateItem(0);

            // 设置定时器
            this.interval = setInterval(() => {
                this.nextItem();
            }, this.time);
        }

        // 激活指定索引的项目
        activateItem(index) {
            // 移除所有active类
            this.items.forEach(item => item.classList.remove('active'));

            // 添加active类到指定项目
            if (this.items[index]) {
                this.items[index].classList.add('active');
                this.currentIndex = index;
            }
        }

        // 切换到下一个项目
        nextItem() {
            const nextIndex = (this.currentIndex + 1) % this.items.length;
            this.activateItem(nextIndex);
        }

        // 清理
        disconnectedCallback() {
            if (this.interval) {
                clearInterval(this.interval);
            }
            if (this.observer) {
                this.observer.disconnect();
            }
        }
    });
}